import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './GenderSelection.css';

function GenderSelection() {
    const navigate = useNavigate();
    const { user, loading } = useAuth();

    useEffect(() => {
        // If user is already logged in, redirect to appropriate dashboard
        if (!loading && user) {
            if (user.gender === 'female' && !user.isApproved) {
                navigate('/waiting');
            } else if (user.gender === 'female' && user.isApproved) {
                navigate('/female-dashboard');
            } else if (user.gender === 'male') {
                navigate('/male-dashboard');
            }
        }
    }, [user, loading, navigate]);

    const handleGenderSelect = (gender) => {
        localStorage.setItem('selectedGender', gender);
        
        // If user is already logged in, redirect directly
        if (user) {
            if (user.gender === 'female' && !user.isApproved) {
                navigate('/waiting');
            } else if (user.gender === 'female' && user.isApproved) {
                navigate('/female-dashboard');
            } else {
                navigate('/male-dashboard');
            }
        } else {
            navigate('/auth');
        }
    };

    return (
        <div className="gender-selection">
            <div className="container">
                <h1>Welcome to Next</h1>
                <p className="subtitle">Please select your gender to continue</p>
                
                <div className="gender-options">
                    <div 
                        className="gender-card male" 
                        onClick={() => handleGenderSelect('male')}
                    >
                        <div className="icon">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M9 9c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.7-1.3 3-3 3s-3-1.3-3-3zm3 5c-4.2 0-6.5 2.2-6.5 3.5V19h13v-1.5c0-1.3-2.3-3.5-6.5-3.5z"/>
                            </svg>
                        </div>
                        <h2>Male</h2>
                        <p>Connect with female models</p>
                    </div>

                    <div 
                        className="gender-card female" 
                        onClick={() => handleGenderSelect('female')}
                    >
                        <div className="icon">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2C10.9 2 10 2.9 10 4s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 4c-1.1 0-2 .9-2 2v7h4V8c0-1.1-.9-2-2-2zm-3 7.5V22h2v-6.5h2V22h2v-8.5z"/>
                            </svg>
                        </div>
                        <h2>Female</h2>
                        <p>Earn money by chatting</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GenderSelection;
